import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../logo.png";

const MenuIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-6 h-6">
    <path d="M3 12h18M3 6h18M3 18h18" />
  </svg>
);
const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-6 h-6">
    <path d="M18 6L6 18M6 6l12 12" />
  </svg>
);
const TwitterIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);
const GithubIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0 1 12 6.844a9.59 9.59 0 0 1 2.504.337c1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0 0 22 12.017C22 6.484 17.522 2 12 2z" />
  </svg>
);
const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const NAV_ITEMS = [
  { label: "About", to: "/about" },
  { label: "Projects", to: "/#projects" },
  { label: "CRM", to: "/crm" },
  { label: "ClaimGuard NEMT", to: "/services/nemt-solutions" },
  // { label: "Security Guard", to: "/services/security-guard-solutions" }, // hidden for now
  { label: "Contact", to: "/contact" },
];

const SERVICE_LINKS = [
  { label: "Web Development", href: "/services/web-development" },
  { label: "Mobile Apps", href: "/services/mobile-apps" },
  { label: "Backend Engineering", href: "/services/backend-engineering" },
  { label: "Cloud Solutions", href: "/services/cloud-solutions" },
  { label: "UI/UX Design", href: "/services/uiux-design" },
  { label: "AI & Automation", href: "/services/ai-automation" },
  { label: "ClaimGuard NEMT", href: "/services/nemt-solutions" },
  // { label: "Security Guard Solutions", href: "/services/security-guard-solutions" }, // hidden for now
  { label: "AI Solutions", href: "/ai-services" },
  { label: "SEO Services Texas", href: "/seo-services" },
];

const DROPDOWN_SERVICES = [
  { label: "Web Development", to: "/services/web-development" },
  { label: "Mobile Apps", to: "/services/mobile-apps" },
  { label: "Backend Engineering", to: "/services/backend-engineering" },
  { label: "Cloud Solutions", to: "/services/cloud-solutions" },
  { label: "UI/UX Design", to: "/services/uiux-design" },
  { label: "AI & Automation", to: "/services/ai-automation" },
  { label: "ClaimGuard NEMT", to: "/services/nemt-solutions" },
  // { label: "Security Guard Solutions", to: "/services/security-guard-solutions" }, // hidden for now
  { label: "AI Solutions", to: "/ai-services" },
  { label: "SEO Services Texas", to: "/seo-services" },
];

function ServicesDropdown({ onClick }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isActive = location.pathname.startsWith("/services") ||
    location.pathname === "/ai-services" ||
    location.pathname === "/seo-services";

  return (
    <div
      className="relative"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        className={`flex items-center gap-1 px-4 py-2 text-sm transition-colors duration-200 rounded-lg hover:bg-white/5 font-medium tracking-wide ${isActive ? "text-white" : "text-slate-400 hover:text-white"}`}
      >
        Services
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className={`w-3 h-3 transition-transform duration-200 ${open ? "rotate-180" : ""}`}>
          <path d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="absolute top-full left-0 pt-2 z-50 min-w-[220px]">
          <div className="rounded-2xl border border-white/10 bg-[#0a0d1a]/95 backdrop-blur-xl shadow-2xl shadow-black/50 p-2">
            <Link
              to="/services"
              onClick={onClick}
              className="flex items-center gap-2 px-3 py-2 rounded-lg text-xs text-violet-400 hover:text-white hover:bg-violet-500/10 transition-colors font-semibold uppercase tracking-wider mb-1"
            >
              View All Services →
            </Link>
            <div className="h-px bg-white/5 mb-1" />
            {DROPDOWN_SERVICES.map((svc) => (
              <Link
                key={svc.to}
                to={svc.to}
                onClick={onClick}
                className={`flex items-center px-3 py-2 rounded-lg text-sm transition-colors ${
                  location.pathname === svc.to
                    ? "text-white bg-white/5"
                    : "text-slate-400 hover:text-white hover:bg-white/5"
                }`}
              >
                {svc.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function NavLink({ item, onClick }) {
  const location = useLocation();
  const isHash = item.to.startsWith("/#");

  if (isHash) {
    return (
      <a
        href={item.to}
        onClick={onClick}
        className="nav-underline px-4 py-2 text-sm text-slate-400 hover:text-white transition-colors duration-200 rounded-lg hover:bg-white/5 font-medium tracking-wide"
      >
        {item.label}
      </a>
    );
  }

  const active = location.pathname === item.to;
  return (
    <Link
      to={item.to}
      onClick={onClick}
      className={`nav-underline px-4 py-2 text-sm transition-colors duration-200 rounded-lg hover:bg-white/5 font-medium tracking-wide ${active ? "text-white" : "text-slate-400 hover:text-white"}`}
    >
      {item.label}
    </Link>
  );
}

function SharedNavBar({ scrolled, mobileOpen, setMobileOpen }) {
  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050810]/90 backdrop-blur-xl border-b border-white/5 shadow-2xl shadow-black/30"
          : "bg-[#050810]/90 backdrop-blur-xl border-b border-white/5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <Link to="/" className="flex items-center gap-3">
            <img src={logo} alt="BerryByte Innovations" />
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            <ServicesDropdown />
            {NAV_ITEMS.map((item) => (
              <NavLink key={item.label} item={item} />
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/contact"
              className="px-5 py-2.5 rounded-xl text-sm font-semibold bg-gradient-to-r from-violet-600 to-cyan-600 text-white hover:from-violet-500 hover:to-cyan-500 transition-all duration-200 shadow-lg shadow-violet-900/30 hover:shadow-violet-900/50 hover:-translate-y-0.5"
            >
              Get Started
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden text-slate-400 hover:text-white transition-colors p-1"
          >
            {mobileOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>
      </div>

      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          mobileOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-6 py-4 bg-[#050810]/95 backdrop-blur-xl border-t border-white/5 flex flex-col gap-1">
          {/* Services group */}
          <div>
            <Link
              to="/services"
              onClick={() => setMobileOpen(false)}
              className="flex items-center justify-between px-4 py-2 text-sm text-slate-400 hover:text-white font-medium rounded-lg hover:bg-white/5 transition-colors"
            >
              Services
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-3 h-3">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </Link>
            <div className="ml-4 mt-1 flex flex-col gap-1 border-l border-white/5 pl-4">
              {DROPDOWN_SERVICES.map((svc) => (
                <Link
                  key={svc.to}
                  to={svc.to}
                  onClick={() => setMobileOpen(false)}
                  className="py-1.5 text-sm text-slate-500 hover:text-white transition-colors"
                >
                  {svc.label}
                </Link>
              ))}
            </div>
          </div>
          {NAV_ITEMS.map((item) => (
            <NavLink key={item.label} item={item} onClick={() => setMobileOpen(false)} />
          ))}
          <Link
            to="/contact"
            onClick={() => setMobileOpen(false)}
            className="mt-2 px-4 py-3 rounded-xl text-center text-sm font-semibold bg-gradient-to-r from-violet-600 to-cyan-600 text-white"
          >
            Get Started
          </Link>
        </div>
      </div>
    </header>
  );
}

function SharedFooter() {
  return (
    <footer className="bg-[#030508] border-t border-white/5 py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-3">
              <img src={logo} alt="BerryByte Innovations" />
            </Link>
            <p className="text-slate-500 text-sm leading-relaxed mt-3">
              Engineering the future, one commit at a time. Trusted by startups and enterprises across the US & Canada.
            </p>
            <div className="flex gap-3 mt-5">
              {[
                { Icon: TwitterIcon, href: "https://x.com/berryByte4", label: "Twitter" },
                { Icon: GithubIcon, href: "https://github.com/berrybyte", label: "GitHub" },
                { Icon: LinkedInIcon, href: "https://www.linkedin.com/company/berrybyteinnovations/", label: "LinkedIn" },
              ].map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-9 h-9 rounded-xl border border-white/8 bg-white/[0.03] flex items-center justify-center text-slate-500 hover:text-white hover:border-white/15 hover:bg-white/[0.06] transition-all duration-200"
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Services</h4>
            <ul className="flex flex-col gap-2.5">
              {SERVICE_LINKS.map(({ label, href }) => (
                <li key={label}>
                  <Link to={href} className="text-slate-500 hover:text-slate-300 text-sm transition-colors duration-200">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Company</h4>
            <ul className="flex flex-col gap-2.5">
              {[
                { label: "About Us", to: "/about" },
                { label: "Services", to: "/services" },
                { label: "CRM Platform", to: "/crm" },
                { label: "Projects", to: "/#projects" },
                { label: "Contact", to: "/contact" },
              ].map(({ label, to }) => (
                <li key={label}>
                  <Link to={to} className="text-slate-500 hover:text-slate-300 text-sm transition-colors duration-200">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Contact</h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-2 text-sm text-slate-500">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-4 h-4 mt-0.5 flex-shrink-0">
                  <path d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                </svg>
                <a href="mailto:sales@berrybyteinn.com" className="hover:text-slate-300 transition-colors">sales@berrybyteinn.com</a>
              </li>
              <li className="flex items-start gap-2 text-sm text-slate-500">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-4 h-4 mt-0.5 flex-shrink-0">
                  <path d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25z" />
                </svg>
                <a href="tel:+12018469830" className="hover:text-slate-300 transition-colors">+1 201-846-9830</a>
              </li>
              <li className="flex items-start gap-2 text-sm text-slate-500">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-4 h-4 mt-0.5 flex-shrink-0">
                  <path d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                  <path d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0z" />
                </svg>
                <div className="flex flex-col gap-0.5">
                  <span>Texas, United States</span>
                  <span>Karachi, Pakistan</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-600 text-sm">
            &copy; {new Date().getFullYear()} BerryByte Innovations. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <Link to="/privacy-policy" className="text-slate-600 hover:text-slate-400 text-xs transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-slate-600 hover:text-slate-400 text-xs transition-colors">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default function SharedLayout({ children }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className="font-sans antialiased text-white bg-[#050810]"
      style={{ fontFamily: "'DM Sans', 'Inter', system-ui, sans-serif" }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;0,9..40,800;0,9..40,900&display=swap');
        html { scroll-behavior: smooth; }
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { width: 6px; }
        ::-webkit-scrollbar-track { background: #050810; }
        ::-webkit-scrollbar-thumb { background: #2d2f45; border-radius: 3px; }
        ::-webkit-scrollbar-thumb:hover { background: #4c4e6a; }

        /* Nav link underline sweep — matches homepage navbar */
        .nav-underline { position: relative; }
        .nav-underline::after {
          content: ""; position: absolute; left: 16px; right: 16px; bottom: 5px;
          height: 1.5px; border-radius: 2px;
          background: linear-gradient(90deg, #8b5cf6, #22d3ee);
          transform: scaleX(0); transform-origin: left;
          transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1);
        }
        .nav-underline:hover::after { transform: scaleX(1); }
        @media (prefers-reduced-motion: reduce) {
          .nav-underline::after { transition: none; }
        }
      `}</style>
      <SharedNavBar scrolled={scrolled} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <main>{children}</main>
      <SharedFooter />
    </div>
  );
}
